const o = "_dialogContentWrapper_1yxdh_1", a = "_dialogContent_1yxdh_1", l = "_smallSize_1yxdh_21", n = "_fullSize_1yxdh_25", t = "_fullZoomLayout_1yxdh_32", e = "_hasLoading_1yxdh_40", d = "_dialogOverlay_1yxdh_44", _ = "_loaderContainer_1yxdh_50", i = {
  dialogContentWrapper: o,
  dialogContent: a,
  smallSize: l,
  fullSize: n,
  fullZoomLayout: t,
  hasLoading: e,
  dialogOverlay: d,
  loaderContainer: _
};
export {
  i as default,
  a as dialogContent,
  o as dialogContentWrapper,
  d as dialogOverlay,
  n as fullSize,
  t as fullZoomLayout,
  e as hasLoading,
  _ as loaderContainer,
  l as smallSize
};
//# sourceMappingURL=index.es5729.js.map
